import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { getApiDataWithToken } from "views/utils/CallApi";
import { CtxAuth } from "views/utils/Contexts";
import * as mb from "views/common/MessageBox";
import { pageNoCurrent, pageMaxCurrent, allPage, pageSend, selectPage} from "views/utils/PagingFunc"

interface IFServiceHistory {
    serviceId: number,
    serviceName: string,
    categoryId: number,
    categoryName: string,
    servicePrice: number,
    serviceSortNo: number,
    serviceDeleteFlg: boolean,
    servicePageNo: number
}

interface IFCategoryHistory {
    categoryId: string,
    categoryName: string
}

interface IFQuantity {
    pages: number
}

export function ServiceList(): JSX.Element{
    
        const cua = useContext(CtxAuth);
        const [msgArgs, setMsgArgs] = useState({type:"", text:""});
        const [serviceHistory, setServiceHistory] = useState<IFServiceHistory[]>();
        const [categoryHistory, setCategoryHistory] = useState<IFCategoryHistory[]>();
        const [pageQuantity, setPageQuantity] = useState<IFQuantity[]>();
        const [maxPage, setMaxPage] = useState<number>(0);
        const url = new URL(window.location.href);
        const params = url.searchParams;

        //-------------------------------------------------------------
        //プルダウンリスト選択時、categoryIdで絞ってサービスを取得
        //-------------------------------------------------------------  
        const selectCategory = (event: React.ChangeEvent<HTMLSelectElement>) => {

            //URLにカテゴリIDを持たせて再表示
            var url = window.location.href;
            var new_url = url.replace(/\?.*$/,"");
            const value = event.target.value;

            if(value === "default-category"){
                window.location.href = new_url
            }else{
                window.location.href = new_url + "?categoryId=" + value;
            }
        };

        useEffect(function(){

            //-------------------------------------------------------------
            //プルダウンリストに表示するカテゴリーの取得
            //------------------------------------------------------------- 
            const ctHistory:IFCategoryHistory[] = [];
            getApiDataWithToken('/management/categories',
                {},
                cua.getToken(),
                function(res:AxiosResponse<any>){
                    switch (res.status){
                        case 200:

                            for (let index = 0; index < res.data.category_list.length; index++) {
                                ctHistory.push({categoryId:res.data.category_list[index].category_id, 
                                categoryName: categorySlice(res.data.category_list[index].category_name)});
                            }
                            setCategoryHistory(ctHistory);
                            break;
                        default:
                            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                    }
                }
            );

            //-------------------------------------------------------------
            //サービスの取得
            //------------------------------------------------------------- 
            if (params.get('categoryId') != null) {

                //選択されたカテゴリーのサービス取得
                let apiUrl =  `/management/services/${params.get('categoryId')}`
                getApiDataWithToken(apiUrl,
                    {},
                    cua.getToken(),
                    function(res:AxiosResponse<any>){
                        switch (res.status){
                            case 200:
                                //データの取得
                                setResData(res);
                                break;

                            default:
                                setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"サービスの取得に失敗しました。"});
                        }
                    }
                );
            }else{  
                //サービス取得
                getApiDataWithToken(`/management/services`,
                    {},
                    cua.getToken(),
                    function(res:AxiosResponse<any>){
                        switch (res.status){
                            case 200:
                                //データの取得
                                setResData(res);
                                break;

                            default:
                                setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"サービスの取得に失敗しました。"});
                        }
                    }
                );
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        //-------------------------------------------------------------
        //サービス取得関数
        //------------------------------------------------------------- 
        function setResData(res:any){
            const srHistory:IFServiceHistory[] = [];
            for (let index = 0; index < res.data.service_list.length; index++) {
                srHistory.push({serviceId:res.data.service_list[index].service_id,
                serviceName:res.data.service_list[index].service_name,
                categoryId:res.data.service_list[index].category_id, 
                categoryName:res.data.service_list[index].category_name, 
                servicePrice:res.data.service_list[index].service_price, 
                serviceSortNo:res.data.service_list[index].service_sort_no, 
                serviceDeleteFlg:res.data.service_list[index].serviceDeleteFlg,
                servicePageNo:res.data.service_list[index].page_no});
            }

            const qHistory:IFQuantity[] = [];
            const array = allPage(res.data.page_max_no);
            for (let index = 0; index < res.data.page_max_no; index++) {
                qHistory.push({
                    pages:array[index]
                });
            }

            var url = window.location.href;
            var pageOption = []
            if (url.match(/pageNo=/)) {
                var pageNoStart = url.indexOf('pageNo=');
                var pageNoEnd = url.indexOf('maxPage=');
                var result = Number(url.substring((pageNoStart + 7), (pageNoEnd - 1)));
                pageOption = srHistory.filter(item => item.servicePageNo === result);
            } else {
                pageOption = srHistory.filter(item => item.servicePageNo === 1);
            }
            
            setPageQuantity(qHistory);
            setServiceHistory(pageOption);
            setMaxPage(res.data.page_max_no);

        }

        //-------------------------------------
        //カテゴリ名文字制限
        //-------------------------------------
        function categorySlice(val: string){
            if (val.length > 20){
                val = (val.slice(0, 20) + "...")
            }
            return val;
        }

    return (
        <AdminFrame>
            <div className="contents">
                <mb.MessageBox args={msgArgs} />
                <h2 className="settings-title-h2">サービス管理</h2>
                <div className="control-horizon control-between">
                    <button className="btn-secondary" onClick={function(){window.location.href='edit'}}>新規登録</button>
                    <div className="control-horizon control-vcenter">
                        <span className="material-icons-round"><a href="list">filter_list</a></span>
                        <div className="select">
                            <select id="categoryid" value={params.get('categoryId') ?? "default-category"} onChange={selectCategory} >
                            <option  value="default-category">すべて</option>
                                {categoryHistory?.map(function (val, idx) {
                                    return (
                                        <option key={idx} value={val.categoryId}>{val.categoryName}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="tbl-wrap">
                    <table className="tbl margin-tb-20">
                        <thead>
                            <tr>
                            <th style={{width: "180px"}}>ID</th>
                            <th style={{minWidth: "200px"}}>名前</th>
                            <th style={{width: "300px"}}>カテゴリ</th>
                            <th style={{width: "180px"}} className="text-price">単価</th>
                            <th style={{width: "100px"}} className="text-num">表示順</th>
                            </tr>
                        </thead>
                        <tbody>
                            {serviceHistory?.map(function(val, idx){
                                return(
                                    <tr key={idx}>
                                        <td>{val.serviceId}</td>
                                        <td><a href={"edit?serviceId=" + val.serviceId}>{val.serviceName}</a></td>
                                        <td>{val.categoryName}</td>
                                        <td className="text-price">{val.servicePrice}</td>
                                        <td className="text-num">{val.serviceSortNo}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <ul className="pagenation">

                {(() => {
                    if (pageNoCurrent() > 1) {
                        if(params.get('categoryId')){
                            return(<li><a href={"?categoryId=" + params.get('categoryId') + "&pageNo=" + pageSend(0) + "&maxPage=" + maxPage}>＜</a></li>)
                        }else{
                            return(<li><a href={"?pageNo=" + pageSend(0) + "&maxPage=" + maxPage}>＜</a></li>)
                        }  
                    }else{
                        return(<li><a href="/#" onClick={e => e.preventDefault()}>＜</a></li>)
                    } 
                })()}

                    {pageQuantity?.map(function(val, idx){
                        return(
                            <li key={idx}>
                                <ul>
                                {(() => {
                                    if (!selectPage(val.pages)) {
                                        if(params.get('categoryId')){
                                            return(<a href={"?categoryId=" + params.get('categoryId') + "&pageNo=" + val.pages + "&maxPage=" + maxPage}>{val.pages}</a>)
                                        }else{
                                            return(<a href={"?pageNo=" + val.pages + "&maxPage=" + maxPage}>{val.pages}</a>)
                                        }  
                                    }else{
                                        return(<li className="is-current">{val.pages}</li>)
                                    } 
                                })()}
                                </ul>
                            </li>
                        )
                    })}

                {(() => {
                    if (pageMaxCurrent(maxPage)) {
                        if(params.get('categoryId')){
                            return(<li><a href={"?categoryId=" + params.get('categoryId') + "&pageNo=" + pageSend(1) + "&maxPage=" + maxPage}>＞</a></li>)
                        }else{
                            return(<li><a href={"?pageNo=" + pageSend(1) + "&maxPage=" + maxPage}>＞</a></li>)
                        }  
                    }else{
                        return(<li><a href="/#" onClick={e => e.preventDefault()}>＞</a></li>)
                    } 
                })()}
                </ul> 
            </div>
        </AdminFrame>
    )
}